import { createRouter, createWebHistory } from "vue-router";
import Home from "../views/Home.vue";
import Services from "../views/Services.vue";
import Pricelist from "../views/Pricelist.vue";
import Gallery from "../views/Gallery.vue";
import Contact from "../views/Contact.vue";

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home,
  },
  {
    path: "/sluzby",
    name: "Services",
    component: Services,
  },
  {
    path: "/cenik",
    name: "Pricelist",
    component: Pricelist,
  },
  {
    path: "/galerie",
    name: "Gallery",
    component: Gallery,
  },
  {
    path: "/kontakt",
    name: "Contact",
    component: Contact,
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

export default router;
